<template>
    <v-container>
      <form class="form-horizontal form-label-left">
        <v-flex md8 lg6 offset-lg3 offset-md2 mt-2>
          <v-subheader>{{$t('profile.profile')}}</v-subheader>

          <v-card>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>{{$t('profile.role')}}:</v-list-tile-sub-title>
                  <v-list-tile-title class="profile-title">{{ edit.roleName }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md8 lg6 offset-lg3 offset-md2 mt-2>
          <v-card>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>{{$t('profile.organization')}}:</v-list-tile-sub-title>
                  <v-list-tile-title class="profile-title">{{ edit.organizationName }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md8 lg6 offset-lg3 offset-md2 mt-2>
          <v-card>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>{{$t('profile.email')}}:<span v-if="!emailVerified" class="label label-warning" style="margin-left: 10px; color: orange;">{{$t('profile.not-verified')}}</span></v-list-tile-sub-title>
                  <v-list-tile-title class="profile-title">{{ edit.email }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list>
              <v-list-tile>
                  <v-flex class="text-xs-center text-md-center text-lg-center">
                    <v-btn v-if="(!emailVerified)" type="button" class="btn warning" v-on:click="openVerifyForm">{{$t('profile.verify')}}</v-btn>
                    <v-btn type="button" class="btn primary" v-on:click="openMailForm">{{$t('profile.change-email')}}</v-btn>
                  </v-flex>
              </v-list-tile>
            </v-list>

            <v-list two-line v-show="(state == 'change_email')">
              <v-list-tile>
                <v-list-tile-content>
                    <v-flex style="width: 100%">
                      <v-text-field
                      type="email"
                      v-model="newEmail"
                      v-bind:class="{'is-error-field': errors.newEmail()}"
                      two-line
                      required
                      :label="$t('profile.new-email')"
                      :rules="emailRules"
                      ></v-text-field>
                    </v-flex>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile class="text-xs-center text-md-center text-lg-center">
                <v-flex class="text-xs-center">
                <v-btn type="button" class="btn default" v-on:click="cancelEmail">{{$t('profile.cancel')}}</v-btn>
                <v-btn type="button" class="btn primary" v-on:click="changeEmail" v-bind:disabled="hasError">{{$t('profile.continue')}}</v-btn>
              </v-flex>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </form>

      <!-- password -->
      <v-form v-show="(state == 'change_password')" class="form-horizontal form-label-left" autocomplete="off" ref="form">
        <v-flex md8 lg6 offset-lg3 offset-md2 mt-4>
          <v-subheader>{{this.$t('profile.change-password-title')}}</v-subheader>

          <v-card>
            <v-alert v-if="passerror" type="error" dismissible v-model="passerror">{{passerror}}</v-alert>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-text-field
                  type="password"
                  v-model="password.old"
                  two-line
                  required
                  :label="$t('profile.old-password')"
                  :rules="oldpassRules"
                  autocomplete="new-password"
                  ></v-text-field>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-text-field
                  type="password"
                  id="passwordNew"
                  v-model="password.new"
                  two-line
                  required
                  :label="$t('profile.new-password')"
                  :rules="newpassRules"
                  autocomplete="new-password"
                  ></v-text-field>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-text-field
                  type="password"
                  id="passwordConfirm"
                  v-model="password.confirm"
                  two-line
                  required
                  :label="$t('profile.confirm-new-password')"
                  :rules="newconfirmpassRules"
                  autocomplete="new-password"
                  ></v-text-field>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list two-line>
              <v-list-tile class="text-xs-center text-md-center text-lg-center">
                <v-flex>
                  <v-btn type="button" class="btn default" v-on:click="cancelPassword">{{$t('profile.cancel')}}</v-btn>
                  <v-btn type="button" class="btn primary" :disabled="hasError" @click="updatePassword">{{$t('profile.submit')}}</v-btn>
                </v-flex>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-form>

      <v-flex md8 lg6 offset-lg3 offset-md2 mt-4>
        <div v-show="(state == '')" class="form-group">
          <v-flex class="text-xs-center text-md-center text-lg-center">
            <v-btn type="button" class="btn warning" v-on:click="openPasswordForm">{{$t('profile.change-password')}}</v-btn>
          </v-flex>
        </div>
      </v-flex>

      <v-flex md8 lg6 offset-lg3 offset-md2 mt-4 v-show="(state == 'confirm')" v-if="(!emailVerified)">
        <v-subheader>{{$t('profile.code-confirm-title')}}</v-subheader>
        <v-card>
          <v-card-title primary-title>
            {{$t('profile.code-confirm-text1')}}
            <br>
            {{$t('profile.code-confirm-text2')}}
          </v-card-title>

          <v-alert v-if="mailerror" type="error" dismissible v-model="mailerror">{{mailerror}}</v-alert>

          <v-flex xs10 offset-xs1>
            <v-text-field
            type="email"
            v-model="confirminationCode"
            v-bind:class="{'is-error-field': errors.confirminationCode()}"
            two-line
            required
            :label="$t('profile.code-confirm-input')"
            autocomplete="new-password"
            ></v-text-field>
          </v-flex>

          <v-flex class="text-xs-center" pb-4>
            <v-btn type="button" class="btn default" v-on:click="cancelEmail">{{$t('profile.cancel')}}</v-btn>
            <v-btn type="button" class="btn warning" v-on:click="resendConfirmationCode">{{$t('profile.resend')}}</v-btn>
            <v-btn type="button" class="btn primary" v-on:click="confirmEmail"
              :loading="loading"
              :disabled="loading"
              @click.native="loader = 'loading'"
            >
              {{$t('profile.confirm')}}
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
          </v-flex>
        </v-card>
      </v-flex>
      <!-- end:confirm -->

            <!-- <delete-confirm-modal :deleteTarget="deleteTarget" @close="deleteTarget=null" v-on:runDelete="deleteAccount"></delete-confirm-modal> -->

        <!-- メッセージ スナックバー -->
        <v-snackbar
            v-model="showSnackbar"
            absolute top right
            :color="snackbarColor"
            :timeout="snackbarTimeout"
        >
            {{snackbarMessage}}
        </v-snackbar>
    </v-container>
</template>

<script>
import cognito from '@/utils/cognito.js'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import ProfileImage from '@/components/ProfileImage.vue'
import DeleteConfirmModal from '@/components/DeleteConfirmModal.vue'
import validate from '@/utils/validate.js'

export default {
  components: {
    ProfileImage,
    DeleteConfirmModal
  },
  data () {
    return {
      state: '',  // change_email or confirm or change_password
      loader: null,
      loading: false,
      edit: {
        id: '',
        username: '',
        email: '',
        roleId: '',
        roleName: '',
        organization: '',
        organizationName: ''
      },
      password: {
        old: '',
        new: '',
        confirm: ''
      },
      oldpassRules: [
        v => !!v || this.$t('profile.vali-blank-old-pass')
      ],
      emailRules: [
        v => validate.emailFormat(v) || this.$t('profile.vali-email-format')
      ],
      newpassRules: [
        v => v.length > 0 || this.$t('profile.vali-blank-new-pass'),
        v => this.rules.checkNewPass(v) || this.$t('profile.vali-format')
      ],
      newconfirmpassRules: [
        v => v.length > 0 || this.$t('profile.vali-blank-confirm-new-pass'),
        v => this.rules.checkSamePass(v) || this.$t('profile.vali-same-password')
      ],
      rules: {
        checkSamePass (v) {
          var n = document.getElementById('passwordNew').value
          if (n === v) {
            return true
          }
          return false
        },
        checkNewPass (v) {
          var n = document.getElementById('passwordNew').value
          if (n.match(/(?=.*[a-z])(?=.*[0-9])/) && n.length >= 8) {
            return true
          } else {
            return false
          }
        }
      },
      organizations: [],
      roles: [],
      deleteTarget: null,
      newEmail: '',
      emailVerified: true,
      confirminationCode: '',
      mailerror: '',
      passerror: '',
      message: '',
      domain: '',
      submitted: false,  // submitフラグ
      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000
    }
  },
  computed: {
    // validator
    errors: function () {
      const self = this
      return {
        newEmail: function () {
          if (self.newEmail.length === 0) {
            return true
          }
          const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!emailRE.test(self.newEmail)) {
            return true
          }
        },
        confirminationCode: function () {
          if (self.confirminationCode.length === 0) {
            return true
          }
        },
        oldPassword: function () {
          if (self.password.old.length === 0) {
            return true
          }
        },
        newPassword: function () {
          if (self.password.new.length === 0) {
            return true
          }
          if (!self.password.new.match(/(?=.*[a-z])(?=.*[0-9])/)) {
            return true
          }
          if (self.password.new.length < 8) {
            return true
          }
          return false
        },
        confirmNewPassword: function () {
          if (self.password.confirm !== self.password.new) {
            return true
          }
        }
      }
    },
    hasError: function () {
      const self = this
      switch (self.state) {
        case 'change_email':
          return self.errors.newEmail()
        case 'confirm':
          return self.errors.confirminationCode()
        case 'change_password':
          return self.errors.oldPassword() ||
            self.errors.newPassword() ||
            self.errors.confirmNewPassword()
      }
      return false
    }
  },
  methods: {
    init () {
      this.getAccount()
      this.getDomainConfig()
    },
    getAccount () {
      const self = this
      http.request('get', '/service2/dashboard/api/accounts/getDetail')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            // console.log('get account data failed(Profile). (' + data.result + ')')
            return
          }
          self.edit.id = data.id
          self.edit.organization = data.organizationId
          self.edit.organizationName = data.organizationName
          self.edit.username = data.username
          self.edit.email = data.email
          self.edit.roleId = data.roles[0]['id']
          self.edit.roleName = data.roles[0]['name']
          if (data.emailVerified === 2) {
            self.emailVerified = false
            self.state = 'confirm'
          } else {
            self.emailVerified = true
            self.state = ''
          }
          cognito.getUserAttributes()
            .then((user) => {
              // console.log(user)
              self.edit.email = user.email
            })
        })
        .catch(() => {
          // TODO エラー処理
          // console.log('error', error)
        })
    },
    openMailForm () {
      this.state = 'change_email'
      this.newEmail = ''
      this.mailerror = ''
    },
    openVerifyForm () {
      this.state = 'confirm'
      this.confirminationCode = ''
      this.mailerror = ''
    },
    changeEmail () {
      cognito.getUserAttributes()
      .then((user) => {
        // console.log(user)
        var params = {
          email: this.newEmail,
          username: user.preferred_username,
          domain: this.domain
        }
        http.request('post', '/service2/dashboard/api/Accounts/updateEmail', params)
        .then(response => {
          this.state = 'confirm'
          this.emailVerified = false
          this.getAccount()
        })
        .catch(error => {
          console.log(error)
          this.showMessage('error', this.$t('account.fail-email-update'))
        })
      })
    },
    resendConfirmationCode () {
      var params = {
        mail: this.edit.email,
        domain: this.domain,
        kind: 'updateMailaddress'
      }
      http.request('post', '/service2/dashboard/api/Accounts/getConfirmationCode', params).then(response => {
      })
    },
    confirmEmail () {
      const self = this
      if (self.confirminationCode.length > 0) {
        var params = {
          kind: 'updateMailaddress',
          code: self.confirminationCode
        }
        http.request('post', '/service2/dashboard/api/Accounts/checkConfirmationCode', params).then(response => {
          console.log(response.data.result)
          const data = response.data
          switch (data.result) {
            case 0:
              alert(self.$t('profile.verified'))
              self.getAccount()
              self.state = ''
              self.newEmail = ''
              self.confirminationCode = ''
              self.mailerror = ''
              break
            default:
              self.mailerror = self.$t('profile.vali-invalid-code')
          }
        })
      } else {
        self.mailerror = this.$t('profile.vali-empty-code')
      }
    },
    cancelEmail () {
      this.state = ''
      this.newEmail = ''
      this.confirminationCode = ''
      this.mailerror = ''
    },
    // 2019/06/11 使用箇所無しと判明
    updateAccountEmail (email) {
      return new Promise((resolve, reject) => {
        http.request('post', '/service/dashboard/api/accounts/update_me', {
          email: email
        })
          .then(response => {
            const data = response.data
            if (data.result !== 0) {
              reject({message: 'Server error'})
            }
            resolve(data)
          })
          .catch(() => {
            // console.log(err)
            reject({message: 'Server error'})
          })
      })
    },
    openPasswordForm () {
      this.state = 'change_password'
      this.$refs.form.reset()
      this.password.old = ''
      this.password.new = ''
      this.password.confirm = ''
      this.passerror = ''
      this.submitted = false // ボタン有効化
    },
    updatePassword () {
      const self = this
      this.submitted = true // ボタン無効化
      this.passerror = ''
      if (this.password.old.length > 0 && this.password.new.length > 0) {
        cognito.changePassword(this.password.old, this.password.new)
          .then(() => {
            alert(self.$t('profile.changed-password'))
            this.state = ''
            this.password.old = ''
            this.password.new = ''
            this.password.confirm = ''
            this.passerror = ''
          })
          .catch(err => {
            // TODO エラー処理
            console.log('error', err)
            switch (err.code) {
              case 'NotAuthorizedException':
                this.passerror = self.$t('profile.change-password-error')
                break
              default:
                this.passerror = self.$t('profile.fail-error')
                break
            }
          })
      }
    },
    cancelPassword () {
      this.state = ''
      this.password.old = ''
      this.password.new = ''
      this.password.confirm = ''
      this.passerror = ''
    },
    deleteAccount () {
      // console.log('delete:' + this.deleteTarget.id)
      http.request('post', '/service/dashboard/api/accounts/forget_me', {forget: 'me'})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            // console.log('delete account failed. (' + data.result + ')')
            this.showError(data.result)
            return
          }
          alert('complete delete')
          this.$router.push('/login')
        })
        .catch(error => {
          // TODO エラー処理
          // console.log('error', error)
          this.showError(error)
        })
    },
    showError (error) {
      this.message = error
    },
    clearMailerror () {
      this.mailerror = ''
    },
    clearPasserror () {
      this.passerror = ''
    },
    clearMessage () {
      this.message = ''
    },
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      this.domain = domainConfig.domain
    },
    showMessage (result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg
          this.snackbarColor = 'red lighten-3'
          this.snackbarTimeout = 6000
          this.showSnackbar = true
          break
        case 'success':
          this.snackbarMessage = msg
          this.snackbarColor = 'teal lighten-2'
          this.snackbarTimeout = 3000
          this.showSnackbar = true
          break
        default:
          return
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.is-error{
  color: #F00;
  text-align: left;
}
.profile-title {
  font-weight: bold;
}
.edit-area {
  background: #ddd !important;
}
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// Profile.vue?0c0f9b32